<script>
    import { createEventDispatcher } from "svelte";
    import TableFooter from "./TableFooter.svelte";

    export let columns = [];
    export let page;
    export let totalPages;
    export let size;
    export let rowCount = 0;
    export let totalCount = 0;
    export let subject = "";
    export let isLoading = false;

    const dispatch = createEventDispatcher();

    function changeSort(tableColumn) {
        if(!tableColumn.isSortable) {
            return;
        }

        columns = columns.map((column) => {
            if (column.fieldName === tableColumn.fieldName) {
                return { ...column, sortValue: !column.sortValue ? "asc" : column.sortValue === "asc" ? "desc" : "" };
            }

            return column;
        });

        dispatch(
            "sort",
            columns.filter((c) => c.isSortable && !!c.sortValue).map((c) => ({ field: c.fieldName, sort: c.sortValue }))
        );
    }
</script>

<div class="h-full relative flex flex-col gap-3 w-full shadow-lg rounded bg-white min-h-400-px p-4">
    <div class="w-full flex-col items-start">
        <slot name="actions"/>
    </div>

    <slot name="searchbar" />

    <slot name="extra" />

    <div class="block w-full overflow-x-auto h-600-px no-scroll">
        <table class="w-full bg-transparent no-scroll">
            <thead class="sticky -top-0.5 w-full z-3 bg-white h-4">
                <tr class="shadow">
                    {#each columns as col}
                        <th on:click|preventDefault={() => changeSort(col)}
                            class="{col.isSortable ? 'cursor-pointer' : ''} border-none p-0 whitespace-nowrap overflow-ellipsis overflow-hidden md:max-w-none"
                            style="max-width: 10rem"
                        >
                            {col?.displayName} {col?.sortValue ? col.sortValue === "asc" ? "↑" : "↓" : "" }
                        </th>
                    {/each}
                </tr>

            </thead>

            <tbody>
                {#if !!isLoading}
                    {#each Array(8) as _ }
                        <tr class="border-b animate-pulse bg-gray-100" style="height: 5rem">
                            {#each Array(columns.length) as _ }
                                <td class="w-auto"></td>
                            {/each}
                        </tr>
                    {/each}
                {:else if !isLoading && !rowCount}
                    <td class="font-semibold text-center" style="height: 40rem" colspan={columns.length}>Non ci sono {subject.toLowerCase()}</td>
                {:else if !isLoading}
                    <slot name="tableContent" />
                {/if}
            </tbody>

        </table>
    </div>

    <div class="sticky bg-white">
        <TableFooter
            bind:page
            bind:totalPages
            bind:size
            bind:totalCount
            colspan={columns.length}
            subject={subject}
        />
    </div>
</div>